/**
 * Keep-screen-awake runner. Watches the setting and holds/releases the screen
 * wake lock live, and restores the persisted choice on load. Mirrors GlassRunner.
 * Renders nothing.
 */
import { useEffect } from 'react';
import { useSettingsStore } from '@/store/settings';
import { setKeepAwake } from '@/ui/wakeLock';

export function KeepAwakeRunner() {
  const keepScreenAwake = useSettingsStore((s) => s.keepScreenAwake);
  useEffect(() => {
    setKeepAwake(keepScreenAwake);
    return () => setKeepAwake(false);
  }, [keepScreenAwake]);
  return null;
}
